export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/recipeType/state.js